import {
  CircularProgress,
  LinearProgress,
  linearProgressClasses,
  styled,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import useCurrency from 'hooks/useCurrency';

export default function DebtCard({
  analyticData,
  title,
  type,
  onClick = () => {},
}) {
  const { t } = useTranslation();
  const { currencyData } = useCurrency();

  const progress =
    (analyticData?.data?.monthsum
      ? analyticData?.data?.monthsum / analyticData?.data?.totalsum
      : analyticData?.data?.monthvalute / analyticData?.data?.totalvalute) || 0;

  return (
    <div
      className={`${
        type === 'monthly' ? 'monthly cursor-pointer' : 'total'
      } price-item-wrapper !base-border !shadow-md !text-black col-span-12 sm:col-span-6 md:col-span-4`}
      onClick={onClick}
    >
      <div className='price-item-title !text-lg mb-1 font-bold'>{title}</div>
      <div className='price-item-sum'>
        {analyticData.isLoading || analyticData.isFetching ? (
          <div className='flex my-1'>
            <CircularProgress size={20} color='inherit' />
          </div>
        ) : (
          <div>
            <div className='flex items-center justify-between text-lg'>
              {(
                type === 'monthly'
                  ? analyticData?.data?.monthsum
                  : analyticData?.data?.totalsum
              ) ? (
                <>
                  <div className='text-gray-500'>UZS: </div>
                  <div>
                    <NumericFormat
                      value={
                        type === 'monthly'
                          ? analyticData?.data?.monthsum
                          : analyticData?.data?.totalsum
                      }
                      displayType={'text'}
                      allowNegative={false}
                      thousandSeparator={' '}
                      decimalScale={2}
                      className='bg-transparent font-bold'
                      suffix={' UZS'}
                    />
                    &nbsp; (
                    <NumericFormat
                      value={
                        type === 'monthly'
                          ? analyticData?.data?.monthsum / currencyData?.sum
                          : analyticData?.data?.totalsum / currencyData?.sum
                      }
                      displayType={'text'}
                      allowNegative={false}
                      thousandSeparator={' '}
                      decimalScale={2}
                      className='bg-transparent font-bold'
                      suffix={' $'}
                    />
                    )
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
            <div className='flex items-center justify-between text-lg'>
              {(
                type === 'monthly'
                  ? analyticData?.data?.monthvalute
                  : analyticData?.data?.totalvalute
              ) ? (
                <>
                  <div className='text-gray-500'>USD: </div>
                  <div>
                    <NumericFormat
                      value={
                        type === 'monthly'
                          ? analyticData?.data?.monthvalute
                          : analyticData?.data?.totalvalute
                      }
                      displayType={'text'}
                      allowNegative={false}
                      thousandSeparator={' '}
                      decimalScale={2}
                      className='bg-transparent font-bold'
                      suffix={' $'}
                    />
                    &nbsp; (
                    {(type === 'monthly' && analyticData?.data?.monthvalute) ||
                    (type !== 'monthly' && analyticData?.data?.totalvalute) ? (
                      <NumericFormat
                        value={
                          type === 'monthly'
                            ? analyticData?.data?.monthvalute *
                              currencyData?.sum
                            : analyticData?.data?.totalvalute *
                              currencyData?.sum
                        }
                        displayType={'text'}
                        allowNegative={false}
                        thousandSeparator={' '}
                        decimalScale={2}
                        className='bg-transparent font-bold'
                        suffix={' UZS'}
                      />
                    ) : (
                      ''
                    )}
                    )
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
            <div className='flex items-center justify-between text-lg'>
              <div className='text-gray-500'>{t('common.table.total')}: </div>

              <NumericFormat
                value={
                  type === 'monthly'
                    ? analyticData?.data?.monthsum / +currencyData?.sum +
                      analyticData?.data?.monthvalute
                    : analyticData?.data?.totalsum / +currencyData?.sum +
                      analyticData?.data?.totalvalute
                }
                displayType={'text'}
                allowNegative={false}
                thousandSeparator={' '}
                decimalScale={2}
                className='bg-transparent font-bold'
                suffix={' $'}
              />
              {/* ) */}
            </div>

            {type == 'monthly' ? (
              <div className='mt-2'>
                <BorderLinearProgress
                  value={progress * 100}
                  variant='determinate'
                />
                <div className='w-full relative py-4'>
                  <span
                    className={`absolute -bottom-0 left-1/2 -translate-x-1/2`}
                  >
                    {(progress * 100).toFixed(2)}%{' '}
                    {t('boss.dashboard.fromTotalDebts')}
                  </span>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme, value }) => ({
  height: 15,
  borderRadius: 15,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: `linear-gradient(to right,  #142579 ${100 - value}%, #22f078)`,
    ...theme.applyStyles('dark', {
      backgroundColor: '#4230e8',
    }),
  },
}));
